import $ from 'jquery';

import { trackAccountCreated } from 'chairisher/analytics/auth';
import { trackAccountCreatedForPRT } from 'chairisher/thirdparty/pinterestretargeting';
import { submitForm } from 'chairisher/util/fetch';
import { setEmailModalOptOutCookie } from 'chairisher/view/helper/marketingpromo';
import { executeRecaptchaForForm } from 'chairisher/view/helper/recaptcha';

export default function bindInlineEmailSignup(options) {
    const { captureType, emailTrackingCallback, formSelector } = options;

    $(formSelector).on('submit', async (e) => {
        e.preventDefault();
        const $form = $(e.currentTarget);
        const $container = $form.parent();

        await executeRecaptchaForForm($form[0]);

        const data = await submitForm($form[0], {
            capture_type: captureType,
            path_name: document.location.pathname,
        });

        setEmailModalOptOutCookie();

        if (emailTrackingCallback) {
            emailTrackingCallback();
        }

        if (data.was_account_created) {
            trackAccountCreatedForPRT();
            trackAccountCreated();
        }

        $form.hide();
        $container.addClass('signup-form-success');
        $container.html("<h3>You're on the list!</h3><h4>Stay tuned for some serious eye candy.</h4>");
    });
}
